module.exports = __webpack_public_path__ + "img/loading.557336d4.gif";